// extracted by mini-css-extract-plugin
export default {"displayWrapper":"CounterDisplay_displayWrapper__AIXqF","incorrectValue":"CounterDisplay_incorrectValue__6BPXc"};